import React from 'react';
import { Modal } from 'react-bootstrap';
import { getIcons } from '_helpers';
import { EmailSelectionForm } from './EmailSelection.form';

export { EmailSelectionModal };

function EmailSelectionModal({ show, handleClose, onEmailSelection }) {

    // Fonction pour gérer les données reçues du formulaire
    const handleEmailSelection = (data) => {
        onEmailSelection(data);
        handleClose();
    };

    return (
        <Modal show={show} onHide={handleClose} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    <img src={getIcons('emailOutlinedBlue')} alt='icone suppression'/>
                    Destinataires de l'alerte
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>                
                <EmailSelectionForm onEmailSelection={handleEmailSelection} handleClose={handleClose}/>
            </Modal.Body>
        </Modal>
    );
};
